import { getAuth } from "firebase/auth";
import { Firebase_App } from "../firebase";
import { LOGIN_PATH } from "../env";


export function logout() {
  const auth = getAuth(Firebase_App);

  auth.signOut().then(function() {
    console.log('Signed Out');
    // (window as Window).location = LOGIN_PATH
  }, function(error) {
    console.error('Sign Out Error', error);
  });
}

export function debugAuth() {

  const auth = getAuth(Firebase_App);

  console.log(auth)
  

}